export default {
  contract: {
    reference: 'Contract reference'
  },
  customInvoice: {
    inscription: 'Mercantile Registry Inscription'
  },
  contact: {
    reference: 'Add contract reference',
    customization: 'Invoice customization',
    aditional: 'Additional information claimed by the payer'
  },
  invoiceData: {
    requiredFields: '(*) Required fields',
    general: 'General data',
    modify: 'Modify data',
    modifyContactData: 'Modify contact data',
    search: 'Search in directory',
    manualAdd: 'Add manually',
    equalToClient: 'Buyer data same as client',
    updateProviderData: 'Update data',
    updatedProviderData: 'Provider data successfully updated',
    updateFTData: 'Update Ficha Terceros data'
  }
}
